{
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "submit": "Enviar",
    "search": "Buscar",
    "loading": "Cargando...",
    "yes": "Sí",
    "no": "No",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "confirm": "Confirmar",
    "done": "Completado",
    "remove": "Quitar",
    "add": "Agregar",
    "view": "Ver",
    "create": "Crear",
    "update": "Actualizar",
    "ok": "Aceptar",
    "none": "Ninguno",
    "na": "N/A",
    "prepare": "Preparar",
    "approve": "Aprobar",
    "uploadFiles": "Subir archivos",
    "learnMore": "Más información",
    "user": "usuario",
    "users": "usuarios"
  },
  "nav": {
    "users": "Usuarios",
    "groups": "Grupos",
    "developerApiTokens": "Tokens de API para desarrolladores",
    "permissions": "Permisos",
    "betaFeatures": "Características beta",
    "security": "Seguridad",
    "adminSettings": "Configuración de administrador"
  },
  "pages": {
    "unauthorized": {
      "title": "No autorizado",
      "heading": "¡Lo sentimos!",
      "message": "Parece que no tiene acceso a esta página.",
      "contactSupport": "Si cree que esto es un error, póngase en contacto con Soporte."
    },
    "errorBoundary": {
      "message": "¡Algo ha salido mal!"
    },
    "passwords": {
      "title": "Página de Contraseñas",
      "description": "Cuando esta opción se activa, todos los miembros de su organización tienen la obligación de cambiar su contraseña periódicamente."
    },
    "singleSignOn": {
      "title": "Página de Inicio de Sesión Único"
    },
    "logo": {
      "title": "Subir Logo",
      "description": "Suba el logo de su organización aquí y se mostrará en los documentos exportados."
    }
  },
  "users": {
    "searchPlaceholder": "Buscar usuarios...",
    "filterByGroup": "Filtrar por grupo",
    "inviteUser": "Invitar usuario",
    "setRole": "Establecer rol",
    "addToGroup": "Agregar a grupo",
    "addToGroupCount": "Agregar {{count}} {{pluralized}} a grupo",
    "removeFromGroup": "Quitar del grupo",
    "removeFromGroupCount": "Quitar {{count}} {{pluralized}} del grupo",
    "manageGroups": "Manage groups",
    "manageGroupsCount": "Manage groups for {{count}} {{pluralized}}",
    "editUser": "Editar usuario",
    "removeUser": "Quitar usuario",
    "cancelInvitation": "Cancelar invitación",
    "resendInvitation": "Reenviar invitación",
    "usageMessage": "Está utilizando {{activeUsersCount}} de {{activeUsersLimit}} usuarios activos y {{totalUsersCount}} de {{totalUsersLimit}} usuarios totales disponibles en su plan actual. ¿Necesita más?",
    "upgradeSubscription": "Actualizar su suscripción",
    "addMoreSeats": "Agregar más licencias",
    "table": {
      "fullName": "Nombre completo",
      "email": "Correo electrónico",
      "role": "Rol",
      "jobTitle": "Puesto",
      "department": "Departamento",
      "location": "Ubicación",
      "groups": "Grupos",
      "access": "Acceso"
    },
    "inviteStatus": {
      "pending": "pendiente",
      "declined": "rechazada",
      "accepted": "aceptada"
    },
    "editUsersUsage": "Usuarios de edición (Normal + Calidad): {{activeUsersCount}} de {{activeUsersLimit}}",
    "basicUsersUsage": "Usuarios básicos: {{basicUsersCount}} de {{basicUsersLimit}}",
    "basicUsersUsageUnlimited": "Usuarios básicos: {{basicUsersCount}} (Ilimitado)"
  },
  "reassignEntities": {
    "cancel": "Cancelar",
    "makeReassignments": "Realizar reasignaciones",
    "previous": "Anterior",
    "next": "Siguiente",
    "removeUser": "Eliminar usuario",
    "confirm": "Confirmar",
    "save": "Guardar",
    "allSelected": "Todos los {{count}} seleccionados:",
    "reviewInfo": "Revise la información a continuación",
    "addUserToGroup": "Agregar usuario al grupo",
    "warningMessage": "Si procede con la eliminación, los siguientes usuarios se agregarán a los siguientes grupos requeridos para acceder a documentos con etiquetas privadas:",
    "userAddedToGroups": "{{userName}} se agregará a los grupos:",
    "steps": {
      "owner": "Documentos",
      "changeRequestOwner": "Solicitudes de cambio",
      "approver": "Acciones de aprobación",
      "reviewer": "Acciones de revisión",
      "issues": "Problemas",
      "events": "Eventos",
      "tasks": "Tareas",
      "summary": "Confirmar cambios y eliminar usuario",
      "summaryRefactor": "Confirmar eliminación de usuario",
      "default_owner": "Asignado de evento predeterminado",
      "eventTemplateOwner": "Plantillas de eventos",
      "control": "Controles",
      "documentTemplateOwner": "Plantillas de documentos"
    },
    "columns": {
      "id": "ID",
      "title": "Título",
      "newOwner": "Nuevo propietario",
      "status": "Estado",
      "tags": "Etiquetas",
      "name": "Nombre",
      "prefix": "Prefijo"
    },
    "summary": {
      "documents": "Documentos:",
      "documentTemplates": "Plantillas de documentos:",
      "changeRequests": "Solicitudes de cambio:",
      "controls": "Controles:",
      "eventTemplates": "Plantillas de eventos:",
      "approvalActions": "Acciones de aprobación:",
      "reviewActions": "Acciones de revisión:",
      "issueActions": "Acciones de problemas:",
      "eventActions": "Acciones de eventos:",
      "issueCollaboratorNote": "Si un nuevo propietario ya es colaborador de un evento, se eliminará de sus colaboradores.",
      "taskActions": "Acciones de tareas:",
      "ownershipTransfer": "La propiedad de {{count}} {{type}} se transferirá a {{name}}",
      "ownershipTransferPlural": "La propiedad de {{count}} {{type}}s se transferirá a {{name}}",
      "actionTransfer": "{{count}} acción {{type}} se transferirá a {{name}}",
      "actionTransferPlural": "{{count}} acciones {{type}} se transferirán a {{name}}",
      "eventTemplateTransfer": "{{ownershipType}} de {{count}} plantilla de evento se transferirá a {{name}}",
      "eventTemplateTransferPlural": "{{ownershipType}} de {{count}} plantillas de eventos se transferirán a {{name}}"
    }
  },
  "groups": {
    "subtitle": "Cree y administre grupos de usuarios para organizar su equipo y controlar el acceso",
    "createNewGroup": "Crear nuevo grupo",
    "assignManagers": "Asignar administradores",
    "editGroup": "Editar grupo",
    "deleteGroup": "Eliminar grupo",
    "confirmDeleteTitle": "Confirmar eliminación del grupo",
    "confirmDeleteMessage": "¿Está seguro de que desea eliminar el grupo \"{{groupName}}\"? Eliminar un grupo que forma parte de un Plan de Capacitación de Qualio puede afectar sus asignaciones de capacitación. Consulte la Matriz de Capacitación para identificar los planes afectados.",
    "yesDeleteGroup": "Sí, eliminar grupo",
    "searchPlaceholder": "Buscar grupos o administradores...",
    "table": {
      "groupName": "Nombre del grupo",
      "groupManagers": "Administradores del grupo",
      "includeInReports": "Incluir en reportes de capacitación"
    },
    "noManagers": "--"
  },
  "groupForm": {
    "groupName": "Nombre del grupo",
    "includeInReports": "Incluir en reportes",
    "minLengthError": "Se requiere un mínimo de 1 carácter.",
    "duplicateError": "El grupo con nombre \"{{groupName}}\" ya existe."
  },
  "roles": {
    "basic": "Básico",
    "normal": "Normal",
    "quality": "Calidad"
  },
  "features": {
    "qualityEvents": {
      "name": "Eventos de calidad",
      "description": "Un \"Evento de Calidad\" es un evento que requiere una acción predefinida o una respuesta y un seguimiento de conformidad con los requisitos regulatorios. Los usuarios de Calidad pueden crear un evento, asignar la responsabilidad y autorizar pasos/acciones asociadas.",
      "enable": "Habilitar eventos de calidad",
      "permissions": {
        "manageWorkflow": "Administrar flujo de trabajo",
        "manageAttributes": "Administrar atributos",
        "workOnIssue": "Trabajar en problema",
        "createIssue": "Crear problema",
        "view": "Ver eventos",
        "create": "Crear un evento",
        "workOnExisting": "Trabajar en un evento existente",
        "manageTemplates": "Crear y administrar plantillas de eventos"
      }
    },
    "migrations": {
      "name": "Migraciones",
      "description": "El administrador de migraciones le permite subir fácilmente documentos a Qualio durante la incorporación.",
      "enable": "Habilitar migraciones",
      "permissions": {
        "create": "Crear",
        "view": "Ver",
        "prepare": "Preparar",
        "approve": "Aprobar",
        "uploadFiles": "Subir archivos"
      }
    },
    "suppliers": {
      "name": "Proveedores",
      "description": "La característica Proveedores permite a su equipo configurar su política de proveedores, administrar su Lista de Proveedores Aprobados y almacenar documentos de auditoría de proveedores.",
      "access": "Acceder a Proveedores"
    },
    "designControls": {
      "name": "Controles de Diseño",
      "description": "La característica Controles de Diseño permite la administración eficiente y la documentación del proceso de diseño y desarrollo de su producto, asegurando conformidad y calidad.",
      "access": "Acceder a Controles de Diseño"
    },
    "compliance": {
      "name": "Cumplimiento",
      "description": "La característica Cumplimiento permite a su equipo administrar marcos de trabajo, rastrear el estado de requisitos y demostrar la adherencia a estándares de calidad y regulatorios.",
      "access": "Acceder a Cumplimiento"
    },
    "apiCapabilities": {
      "name": "Capacidades de API",
      "description": "Las Capacidades de API habilitan el acceso a interfaces programables para la integración y automatización perfecta de sus sistemas empresariales con documentos y capacitación de Qualio.",
      "access": "Acceder a Capacidades de API",
      "deprecatedNote": "Esto habilita el acceso solo a la API heredada. Use \"Tokens de API para desarrolladores\" para otorgar acceso a la nueva API."
    },
    "events": {
      "name": "Eventos",
      "description": "La característica Eventos permite a su equipo crear y administrar todos los eventos de calidad desde la causa raíz hasta la verificación de la efectividad."
    },
    "notAvailable": "Esta característica no está disponible con su licencia actual. Póngase en contacto con su representante de Soporte al Cliente para actualizar y habilitar eventos de calidad.",
    "disableConfirmation": "Los datos existentes se guardarán y estarán disponibles cuando las características se reactiven. Sin embargo, cualquier permiso de usuario que haya sido modificado se eliminará y se restablecerá al acceso predeterminado cuando la característica se reactiven. ¿Está seguro de que desea desactivar?",
    "disableTitle": "Desactivar {{name}}",
    "yesDisable": "Sí, desactivar {{name}}",
    "enable": "Habilitar característica",
    "disable": "Desactivar {{name}}",
    "role": "Rol",
    "access": "Acceso",
    "none": "Ninguno",
    "upgradeMessage": "Esta característica no está disponible con su licencia actual. Póngase en contacto con su representante de Éxito del Cliente para actualizar y habilitar eventos de calidad."
  },
  "status": {
    "draft": "Borrador",
    "forReview": "Para revisión",
    "forApproval": "Para aprobación",
    "approved": "Aprobado",
    "approvalDeclined": "Aprobación rechazada",
    "effective": "Vigente"
  },
  "forms": {
    "fullName": "Nombre completo",
    "email": "Dirección de correo electrónico",
    "role": "Rol de usuario",
    "adminAccess": "Acceso de administrador",
    "billingAccess": "Acceso a facturación",
    "learnMoreRoles": "Más información sobre roles de usuario.",
    "labels": {
      "fullName": "Nombre completo",
      "emailAddress": "Dirección de correo electrónico",
      "userRole": "Rol del usuario",
      "jobTitle": "Puesto",
      "department": "Departamento",
      "location": "Ubicación",
      "adminAccess": "Acceso de administrador",
      "billingAccess": "Acceso de facturación",
      "name": "Nombre",
      "role": "Rol",
      "groups": "Grupos"
    },
    "placeholders": {
      "whatIsThisTokenFor": "¿Para qué es este token?",
      "filterByNameEmailGroup": "Filtrar por nombre, correo electrónico o nombre de grupo..."
    },
    "helperText": {
      "adminAccess": "Otorgar acceso de administrador permitirá a los usuarios agregar/quitar usuarios y grupos, y editar permisos",
      "adminAccessExtended": "Otorgar acceso de administrador permitirá a los usuarios agregar/quitar usuarios, agregar/quitar grupos y administrar permisos para eventos y proveedores",
      "inviteUser": "Se enviará un mensaje de invitación a la dirección de correo electrónico proporcionada. Contendrá un enlace de confirmación que permite al propietario de la dirección de correo electrónico unirse a su organización.",
      "learnMoreRoles": "Obtenga más información sobre los roles de usuario.",
      "learnMorePermissions": "Obtenga más información sobre permisos."
    },
    "permissions": {
      "viewEvents": "Ver eventos",
      "createEvents": "Crear un evento",
      "editEvents": "Trabajar en un evento existente",
      "manageEvents": "Crear y gestionar plantillas de eventos",
      "accessSuppliers": "Acceder a proveedores",
      "accessDesignControls": "Acceder a controles de diseño",
      "accessCompliance": "Acceder a cumplimiento"
    }
  },
  "apiCapabilities": {
    "header": "Capacidades API",
    "description": "Las capacidades API permiten el acceso a interfaces programables para la integración y automatización perfecta de sus sistemas empresariales con documentos y capacitación de Qualio.",
    "deprecatedDescription": "Esto habilita el acceso solo a la API heredada. Utilice \"Tokens de API para desarrolladores\" para otorgar acceso a la nueva API.",
    "errorFetchKeys": "No se pudo determinar si la empresa tiene claves API debido a un error del servidor.",
    "access": "Acceder a capacidades API"
  },
  "modals": {
    "inviteUser": {
      "title": "Invitar usuario",
      "sendInvitation": "Enviar invitación",
      "resendInvitation": "Reenviar invitación",
      "reinviteMessage": "{{email}} fue anteriormente un miembro activo de esta cuenta. Reinvitarlos restaurará su perfil con actividades completadas anteriormente."
    },
    "setRole": {
      "title": "Establecer rol para usuarios seleccionados"
    },
    "addToGroup": {
      "title": "Agregar usuarios seleccionados a grupo"
    },
    "manageGroups": {
      "title": "Manage groups for selected users",
      "save": "Save",
      "saving": "Saving...",
      "searchPlaceholder": "Filter by group name..."
    },
    "removeFromGroup": {
      "title": "Quitar usuarios seleccionados del grupo",
      "visibilityWarning": "Quitar a los usuarios seleccionados de este grupo ocultará algunos documentos o plantillas a sus propietarios. ¿Está seguro de que desea continuar?",
      "confirmTitle": "Esta acción afecta la visibilidad del contenido"
    },
    "removeUser": {
      "title": "Quitar usuario",
      "confirmMessage": "¿Está seguro de que desea quitar al usuario \"{{name}}\"?",
      "yesRemoveUser": "Sí, quitar usuario"
    },
    "cancelInvite": {
      "title": "Cancelar invitación",
      "confirmMessage": "¿Está seguro de que desea cancelar la invitación de este usuario?",
      "yesCancelUser": "Sí, cancelar usuario"
    },
    "assignManagers": {
      "title": "Asignar Administradores",
      "searchPlaceholder": "Filtrar por nombre, correo electrónico o nombre de grupo...",
      "assigning": "Asignando...",
      "save": "Guardar"
    },
    "editUser": {
      "title": "Editar usuario"
    },
    "editGroup": {
      "title": "Editar grupo"
    }
  },
  "editUser": {
    "title": "Editar usuario",
    "header": "Editar usuario",
    "general": "General",
    "permissions": "Permisos",
    "defaultPermissions": "Permisos predeterminados",
    "events": "Eventos",
    "suppliers": "Proveedores",
    "designControls": "Controles de diseño",
    "compliance": "Cumplimiento",
    "eventsDescription": "La función de Eventos permite a su equipo crear y gestionar todos los eventos de calidad desde la causa raíz hasta la verificación de efectividad",
    "suppliersDescription": "La función de Proveedores permite a su equipo configurar su política de proveedores, gestionar su Lista de proveedores aprobados y almacenar documentos de auditoría de proveedores",
    "designControlsDescription": "La función de Controles de diseño permite una gestión y documentación eficiente del proceso de diseño y desarrollo de su producto, garantizando cumplimiento y calidad.",
    "complianceDescription": "La función de Cumplimiento permite a su equipo gestionar marcos de trabajo, rastrear el estado de requisitos y demostrar adherencia a estándares de calidad y regulatorios.",
    "eventsWarning": "Ver eventos debe ser seleccionado para habilitar permisos adicionales",
    "viewEventsWarning": "Ver eventos debe ser seleccionado para habilitar permisos adicionales",
    "resetPermissions": "Restablecer permisos predeterminados",
    "resetToDefault": "Restablecer permisos predeterminados",
    "saveChanges": "Guardar cambios",
    "eventsPermissions": "Permisos de eventos",
    "defaultPermissionsTable": {
      "role": "Rol",
      "defaultPermissions": "Permisos predeterminados"
    },
    "validation": {
      "invalidFullName": "Nombre completo no válido",
      "invalidEmail": "Correo electrónico no válido"
    }
  },
  "messages": {
    "success": {
      "saved": "Guardado correctamente",
      "deleted": "Eliminado correctamente",
      "submitted": "Enviado para revisión",
      "invitationSent": "¡Invitación enviada!",
      "invitationResent": "¡La invitación ha sido enviada nuevamente!",
      "invitationCanceled": "Invitación del usuario cancelada correctamente.",
      "userRemoved": "Usuario eliminado correctamente.",
      "userDeleted": "¡Usuario eliminado correctamente!",
      "userUpdated": "¡Usuario actualizado correctamente!",
      "groupCreated": "¡Grupo creado correctamente!",
      "groupDeleted": "¡Grupo eliminado correctamente!",
      "groupUpdated": "¡Grupo actualizado correctamente!",
      "roleChanged": "¡Rol cambiado correctamente para {{count}} usuario(s)!",
      "usersAdded": "{{count}} usuario(s) agregado(s) correctamente al grupo seleccionado",
      "usersRemoved": "{{count}} usuario(s) eliminado(s) correctamente del grupo seleccionado",
      "groupsUpdated": "Successfully updated group membership!",
      "managersAssigned": "Administradores asignados correctamente",
      "permissionsUpdated": "Permisos de instancia actualizado correctamente",
      "tokenCreated": "Nuevo token creado",
      "tokenDeleted": "Token de API para desarrolladores eliminado correctamente",
      "tokenUpdated": "Token de API para desarrolladores actualizado correctamente"
    },
    "error": {
      "generic": "Ocurrió un error. Por favor, inténtelo de nuevo.",
      "notFound": "Elemento no encontrado",
      "unauthorized": "No está autorizado para realizar esta acción",
      "sendInvitation": "¡Algo salió mal! No se pudo enviar la invitación.",
      "resendInvitation": "¡Algo salió mal! No se pudo reenviar la invitación.",
      "cancelInvitation": "¡Algo salió mal! No se pudo cancelar la invitación del usuario.",
      "removeUser": "¡Algo salió mal! No se pudo eliminar el usuario.",
      "updateUser": "¡Algo salió mal! No se pudo actualizar el usuario.",
      "extractOwnedItems": "¡Algo salió mal! No se pudo extraer elementos propiedad de este usuario.",
      "createGroup": "¡Algo salió mal! No se pudo crear el grupo.",
      "deleteGroup": "¡Algo salió mal! No se pudo eliminar el grupo.",
      "updateGroup": "¡Algo salió mal! No se pudo actualizar el grupo.",
      "updateRole": "¡Algo salió mal! No se pudo actualizar el rol.",
      "setUsersToGroup": "No se pudo establecer usuarios al grupo seleccionado",
      "addUsersToGroup": "No se pudo establecer usuarios al grupo seleccionado",
      "removeUsersFromGroup": "No se pudo eliminar usuario(s) del grupo seleccionado",
      "manageGroups": "Unable to update group membership. Please try again.",
      "assignManagers": "Error al asignar administradores",
      "updateMfa": "No se pudo actualizar el estado de MFA para esta empresa",
      "updatePermissions": "Error al actualizar los permisos de instancia",
      "loadSettings": "Error al cargar la configuración.",
      "fetchFeatures": "Error al obtener características",
      "updateFeatures": "Error al actualizar características",
      "createToken": "No se pudo crear la clave de API solicitada debido a un error del servidor",
      "tokenNameExists": "Ya existe una clave de API con este nombre. Elija un nombre diferente.",
      "deleteToken": "No se pudo eliminar la clave de API solicitada debido a un error del servidor",
      "rotateToken": "No se pudo rotar la clave de API solicitada debido a un error del servidor",
      "showApiKeys": "No se pudo mostrar las claves de API debido a un error del servidor",
      "reassignEntities": "Error al reasignar entidades. Por favor, inténtelo de nuevo.",
      "updateToken": "No se pudo actualizar el token de API solicitado debido a un error del servidor"
    },
    "validation": {
      "required": "Este campo es obligatorio",
      "invalidEmail": "Dirección de correo electrónico no válida.",
      "minLength": "Debe tener al menos {{min}} caracteres",
      "maxLength": "No debe tener más de {{max}} caracteres",
      "invalidTokenName": "Nombre de token no válido",
      "minimumAdmins": "Esta operación daría como resultado cero administradores para la empresa. El número mínimo de administradores requeridos para cada empresa es 1.",
      "minimumQuality": "La empresa requiere al menos un usuario de Calidad.",
      "documentsHidden": "Esta acción causaría que uno o más documentos estén ocultos para sus propietarios.",
      "templatesHidden": "Esta acción causaría que una o más plantillas estén ocultas para sus propietarios.",
      "userAlreadyExists": "El usuario registrado con correo electrónico {{email}} ya es miembro de esta empresa.",
      "totalUsersLimit": "Se ha alcanzado el límite de usuarios totales.",
      "activeUsersLimit": "Se ha alcanzado el límite de usuarios activos.",
      "userExistsInQualio": "Un usuario con esta dirección de correo electrónico ya existe en Qualio."
    }
  },
  "emptyStates": {
    "noResults": "No se encontraron resultados",
    "noData": "No hay datos para mostrar.",
    "noBetaFeatures": {
      "title": "No hay características beta activas disponibles",
      "subtitle": "Por favor, vuelva más tarde. Siempre estamos trabajando en mejoras para la experiencia de Qualio."
    },
    "noApiTokens": {
      "title": "No hay tokens de API creados",
      "subtitle": "¿Necesita un token de API para scripts o pruebas? Genere un token de API para acceso rápido a la API de Qualio.",
      "viewPortal": "Ver Portal de Desarrolladores",
      "createToken": "Crear token"
    },
    "noApiAccess": {
      "title": "No tiene acceso a la API de desarrollador",
      "subtitle": "Póngase en contacto con nuestro equipo de soporte para que pueda acceder a la API de desarrollador en Qualio.",
      "contactSupport": "Contactar a soporte de Qualio"
    }
  },
  "security": {
    "description": "Administre los requisitos de autenticación y la configuración de seguridad para todos los usuarios de su organización.",
    "mfa": {
      "label": "Autenticación multifactor",
      "description": "Requerir que todos los usuarios de su organización proporcionen un código de verificación además de su contraseña al iniciar sesión, mejorando la seguridad general.",
      "enable": "Habilitar autenticación multifactor",
      "disableTitle": "Desactivar autenticación multifactor",
      "disableMessage": "¿Está seguro de que desea desactivar esta configuración? Los usuarios no serán obligados a iniciar sesión usando autenticación multifactor una vez desactivada."
    }
  },
  "permissions": {
    "instancePermissions": "Permisos de instancia",
    "aiEditing": {
      "label": "Edición impulsada por IA",
      "description": "Evaluaciones de capacitación sugeridas, controles de cambios y mejoras de documentos impulsadas por IA.",
      "enable": "Habilitar edición impulsada por IA"
    },
    "mcp": {
      "label": "Acceso MCP",
      "description": "Permitir que los asistentes y agentes de IA se conecten a esta instancia a través del servidor MCP de Qualio.",
      "enable": "Habilitar acceso MCP"
    },
    "copilot": {
      "label": "Qualio Copilot",
      "description": "Habilitar el asistente de IA Qualio Copilot para esta instancia.",
      "enable": "Habilitar Copilot"
    },
    "reviewers": {
      "label": "Revisores",
      "description": "Otorgue a los usuarios Básicos el permiso de ser agregados como revisor en documentos.",
      "enable": "Todos los usuarios básicos pueden ser revisores"
    },
    "supportAccess": {
      "label": "Acceso de soporte de Qualio",
      "description": "Permitir que el soporte de Qualio acceda a su instancia en modo de solo lectura.",
      "enable": "Habilitar acceso de soporte"
    },
    "saveChanges": "Guardar cambios",
    "termsOfService": {
      "prefix": "Los permisos marcados con",
      "tos": "habilitan funciones impulsadas por IA. Al habilitarlos, usted acepta estar vinculado por los Términos de Servicio de Qualio.",
      "fairUsage": "Para garantizar una experiencia consistente para todos los usuarios, podemos introducir límites de uso durante períodos de alta demanda."
    }
  },
  "betaFeatures": {
    "description": "Explore y pruebe las características más recientes que estamos creando habilitándolas en su instancia. Sus comentarios nos ayudan a refinar y perfeccionar estas innovaciones, así que déjenos saber qué piensa. Al habilitar una característica beta, puede tomar algunos minutos para que el cambio surta efecto. Si no ve los cambios, intente actualizar su navegador. Obtenga más información sobre estas características en nuestro",
    "helpCenter": "Centro de Ayuda.",
    "packageNotice": "El acceso a las características beta después de su disponibilidad general puede depender de su paquete. Comuníquese con su CSM para obtener más información.",
    "enabled": "{{name}} habilitado",
    "disabled": "{{name}} deshabilitado",
    "enable": "Habilitar {{name}}",
    "termsOfService": {
      "prefix": "Al hacer clic en un botón de alternancia para habilitar cualquiera de las siguientes características beta, usted acepta estar vinculado por",
      "terms": "Términos de Servicio,",
      "middle": "mediante el cual las características beta que habilita serán parte de las \"Características beta\" para los propósitos de los",
      "suffix": "Términos de Servicio."
    }
  },
  "devApi": {
    "backToTokens": "Volver a tokens de API",
    "createToken": "Crear Token",
    "tokenRoleHelper": "¿Qué rol desea que tenga este token?",
    "adminAccessHelper": "Otorgue a este token la capacidad de agregar/quitar usuarios, agregar/quitar grupos y administrar permisos para eventos y proveedores.",
    "tokenGroupsHelper": "Opcionalmente, agregue este token a grupos para permitirle ver documentos, eventos, etc. privados, como un usuario.",
    "editToken": "Editar token"
  },
  "developerApi": {
    "description": "Los tokens de API son claves únicas y seguras que permiten el acceso autenticado a la API de Qualio. Habilitan la integración perfecta con sistemas externos para automatizar flujos de trabajo, sincronizar datos y mejorar el seguimiento de cumplimiento.",
    "manageDescription": "Aquí, puede administrar sus tokens de API. Puede crearlos, eliminarlos y rotarlos. Rotar un token generará una nueva clave de token e invalidará la antigua. El nombre y los permisos no cambiarán.",
    "expirationNote": "Cada token expirará después de un año, si no se rotan. Cualquier acción realizada con la clave se registrará en el registro de auditoría con el nombre que elija para el token.",
    "docsAlert": "¿Está integrando con la API de Qualio? Encuentre guías y la referencia completa de la API en nuestro portal para desarrolladores.",
    "viewApiDocs": "Ver documentación de la API",
    "createToken": "Crear token",
    "backToTokens": "Volver a tokens de API",
    "createTokenHeader": "Crear Token",
    "tokenName": "Nombre",
    "tokenRole": "Rol",
    "tokenRoleHelper": "¿Qué rol desea que tenga este token?",
    "tokenGroups": "Grupos",
    "tokenGroupsHelper": "Opcionalmente, agregue este token a grupos para permitirle ver documentos, eventos, etc. privados, como un usuario.",
    "adminAccessHelper": "Otorgue a este token la capacidad de agregar/quitar usuarios, agregar/quitar grupos y administrar permisos para eventos y proveedores.",
    "tokenCreatedTitle": "Nuevo token creado",
    "storeSecurelyTitle": "Almacene este token de forma segura",
    "storeSecurelyMessage": "Esta es la única vez que podrá ver el token completo.",
    "apiTokenLabel": "Token de API",
    "copyToken": "Copiar token",
    "tokenLostWarning": "Si se pierde el token, deberá generar uno nuevo. Generar un nuevo token invalidará el antiguo, pero tendrá los mismos permisos y nombre.",
    "deleteToken": "Eliminar token de API para desarrolladores",
    "confirmDeleteTitle": "Confirmar eliminación del token",
    "confirmDeleteMessage": "¿Está seguro de que desea eliminar el token \"{{tokenName}}\"? Cualquier integración que utilice este token perderá el acceso a la API de Qualio de inmediato.",
    "confirmRotateTitle": "Confirmar rotación del token",
    "confirmRotateMessage": "¿Está seguro de que desea rotar el token \"{{tokenName}}\"? Esto genera una nueva clave de token e invalida la actual de inmediato, por lo que cualquier integración que la utilice perderá el acceso hasta que se actualice.",
    "table": {
      "name": "Nombre",
      "created": "Creado",
      "expires": "Expira",
      "type": "Tipo",
      "personal": "Personal",
      "system": "Sistema",
      "personalTooltip": "Este token está vinculado a un usuario real y hereda su acceso. Dejará de funcionar si ese usuario se desactiva.",
      "systemTooltip": "Este token no está vinculado a un usuario real y tiene sus propios permisos.",
      "rotate": "Rotar",
      "delete": "Eliminar"
    }
  },
  "reassign": {
    "removeUserTitle": "Quitar Usuario: {{name}}",
    "removeUserTitleGeneric": "Quitar Usuario",
    "description": "Antes de quitar un usuario, debe transferir la propiedad de documentos y problemas, tareas y acciones pendientes a otros usuarios.",
    "descriptionEvents": "Antes de quitar un usuario, debe transferir la propiedad de documentos y eventos, tareas y acciones pendientes a otros usuarios.",
    "descriptionExtended": "Antes de quitar un usuario, debe transferir la propiedad de documentos, plantillas, problemas, tareas y acciones pendientes a otros usuarios.",
    "descriptionExtendedEvents": "Antes de quitar un usuario, debe transferir la propiedad de documentos, plantillas, eventos, tareas y acciones pendientes a otros usuarios.",
    "steps": {
      "documents": "Documentos",
      "changeRequests": "Solicitudes de Cambio",
      "approvalActions": "Acciones de aprobación",
      "reviewActions": "Acciones de revisión",
      "issues": "Problemas",
      "tasks": "Tareas",
      "confirmChanges": "Confirmar cambios y quitar usuario",
      "defaultEventAssignee": "Responsable de evento predeterminado",
      "eventTemplates": "Plantillas de Eventos",
      "controls": "Controles",
      "documentTemplates": "Plantillas de documento"
    },
    "bulkSelect": {
      "allSelected": "Todos {{size}} seleccionados:",
      "save": "Guardar"
    },
    "table": {
      "id": "ID",
      "title": "Título",
      "newOwner": "Nuevo Propietario",
      "status": "Estado",
      "tags": "Etiquetas",
      "name": "Nombre",
      "prefix": "Prefijo"
    },
    "summary": {
      "reviewInfo": "Revise la información a continuación",
      "addUserToGroupTitle": "Agregar usuario a grupo",
      "addUserToGroupMessage": "Si continúa con la eliminación, los siguientes usuarios se agregarán a los siguientes grupos necesarios para acceder a documentos con etiquetas privadas:",
      "userAddedToGroups": "{{userName}} se agregará a los grupos: {{groupNames}}"
    }
  },
  "aria": {
    "userlistCheckbox": "userlist_checkbox",
    "addToGroup": "Add to group",
    "removeFromGroup": "Remove from group",
    "manageGroups": "Manage groups",
    "adminAccess": "admin access",
    "billingAccess": "billing access",
    "email": "email",
    "fullName": "fullName",
    "role": "role",
    "group": "group",
    "groupName": "group name",
    "includeInReports": "include in reports",
    "inviteUserForm": "inviteUserForm",
    "groupForm": "group form",
    "nextButton": "next_button",
    "canViewQualityEvents": "can view quality events",
    "canCreateQualityEvents": "can create quality events",
    "canEditQualityEvents": "can edit quality events",
    "canManageQualityEvents": "can manage quality events"
  }
}
